angular.module('core')
    .service('dblUserAgent', ['$window', function($window) {
        // This service represents the user agent in which this application is running (the web browser). It
        // exposes features of the agent that can be used to enable behavior in the application.
        // It's considered a good practice to check features rather than specific agent types and versions when
        // enabling behavior.

        var getIEVersion = function() {
            var sAgent = window.navigator.userAgent;
            var Idx = sAgent.indexOf("MSIE");

            if (Idx > 0) {
                // If IE, return version number.
                return parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)));
            } else if (!!navigator.userAgent.match(/Trident\/7\./)) {
                // If IE 11 then look for Updated user agent string.
                return 11;
            } else {
                //It is not IE
                return 0;
            }
        };

        // A simple width based test for narrow screens typical of mobile devices.  The idea is to
        // catch portrait iPad and smaller widths for doing things like hiding UI that may not look
        // good on narrow screens.  Usually this is done via CSS media queries, but this is useful when logic is needed in JS.
        var hasMobileWidth = function () {
            return $window.innerWidth <= 768;
        };

        // https://stackoverflow.com/questions/4617638/detect-ipad-users-using-jquery/4617648#4617648
        var isIPad = function () {
            return $window.navigator.userAgent.match(/iPad/i) !== null;
        };

        return {
            getIEVersion: getIEVersion,
            hasMobileWidth: hasMobileWidth,
            isIPad: isIPad
        };
    }]);
